import { observer } from 'mobx-react-lite'
import {
  NoticeBanner,
  NoticeBannerAction,
  NoticeBannerCloseButton,
} from '@/features/shell/notice-banner/NoticeBanner'
import { type Ref, useCallback, useState } from 'react'

interface CallCenterNoticeBannerContainerProps {
  onPress: () => void
  ref?: Ref<HTMLDivElement>
  topOffset?: number
}

export const CallCenterNoticeBannerContainer = observer(
  function CallCenterNoticeBannerContainer({
    onPress,
    ref,
    topOffset,
  }: CallCenterNoticeBannerContainerProps) {
    const [isBannerVisible, setIsBannerVisible] = useState(true)
    const closeAnnouncement = useCallback(() => setIsBannerVisible(false), [])

    return isBannerVisible ? (
      <NoticeBanner ref={ref} topOffset={topOffset}>
        <NoticeBannerAction onPress={onPress}>
          Call for assistance
        </NoticeBannerAction>

        <NoticeBannerCloseButton onPress={closeAnnouncement} />
      </NoticeBanner>
    ) : null
  },
)
